import classes from './Cennik.module.css'
import { useState, useEffect } from 'react';
const Cennik = () => {

    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);
    useEffect(() => {
    const handleWindowResize = () => {
        setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
        window.removeEventListener('resize', handleWindowResize);
    };
    });

    return ( 
        <div className = {classes.Cennik} id="Cennik">
            <div className = {classes.content}>
                <h1>Cenník</h1>
                {windowSize[0]<550 ? <>
                    <div className={classes.miniRiadok}>
                        <p className={classes.miniPar}>Individuálna konzultácia - 50min</p> 
                        <p> 45€</p>                   
                    </div>
                    <div className={classes.miniRiadok}>
                        <p className={classes.miniPar}>Online individuálna konzultácia - 50min</p> 
                        <p> 45€</p>                   
                    </div>                   
                </> : <>
                {windowSize[0]<800 ? <p>Individuálna konzultácia - 50min...................... 45€</p> : <p>Individuálna konzultácia - 50min................................................................... 45€</p>}
                {windowSize[0]<800 ? <p>Online individuálna konzultácia - 50min......... 45€</p>: <p>Online individuálna konzultácia - 50min...................................................... 45€</p>}
                </>}
            </div>
        </div> 
    );
}
 
export default Cennik;